import { Box } from "@mui/material"
import { PdfTaskRows } from "./pdf-task-rows"
import { TaskHeaderRows } from "./task-header-rows"

export function PdfTaskComparisonSection({ item, showUnchangedNote = false }) {
    if (item.isHeader) {
        return (
            <Box component="tbody" sx={{ pageBreakAfter: "auto", breakAfter: "auto" }}>
                <TaskHeaderRows item={item} showUnchangedNote={showUnchangedNote} />
            </Box>
        )
    }

    return (
        <Box
            component="tbody"
            sx={{
                pageBreakAfter: item?.isLastComparisonRow ? "auto" : "always",
                breakAfter: item?.isLastComparisonRow ? "auto" : "page",
            }}
        >
            <PdfTaskRows item={item} showUnchangedNote={showUnchangedNote} />
        </Box>
    )
}
